export const VITE_AUTHORITY ='https://login.microsoftonline.com/common';